<app-light-bottom-svg></app-light-bottom-svg>
<div class="container-fluid text-light bg-gray">
  <div class="animate-to-top row text-center">
    <div class="col-12 mt-5">
      <h1 class="horizontal-line">
        <span class="bg-gray px-3">Skills</span>
      </h1>
    </div>
  </div>

  <div class="animate-to-top row mt-5">
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="html" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="css" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="bootstrap" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="tachyons" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="js" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="ts" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="ramda" class="w-100 h-100"></canvas>
    </div>
    <div class="col-12 col-md-6 col-lg-4 mb-5">
      <canvas id="angular" class="w-100 h-100"></canvas>
    </div>
  </div>
</div>
